import { DocumentNode, gql } from '@apollo/client';
import * as React from 'react';

import { EventAlertDetail_EventAlertFragment } from './graphql-types/EventAlertDetail_EventAlertFragment';

import { AuthorDetail } from './components/AuthorDetail';
import { SponsorDetail } from './components/SponsorDetail';

export const EventAlertDetail: React.FC<{
  eventAlert: EventAlertDetail_EventAlertFragment;
}> & {
  eventAlertFragment: DocumentNode;
} = ({ eventAlert }) => {
  return eventAlert.event?.__typename === 'SimpleEventV2' &&
    eventAlert.event.hostOrganization?._id ? (
    <SponsorDetail simpleEvent={eventAlert.event} />
  ) : (
    <AuthorDetail eventAlert={eventAlert} />
  );
};

EventAlertDetail.eventAlertFragment = gql`
  fragment EventAlertDetail_EventAlertFragment on EventAlert {
    _id
    event {
      _id
      ... on SimpleEventV2 {
        _id
        hostOrganization {
          _id
        }
        ...SponsorDetail_SimpleEventFragment
      }
    }
    ...AuthorDetail_EventAlertFragment
  }
  ${SponsorDetail.simpleEventFragment}
  ${AuthorDetail.eventAlertFragment}
`;
